import Default from '@app/constants';
import { FilterStationLogs } from '@app/typings/services/winnonie/logs';
import { WnnServiceManageTable } from '@app/typings/services/winnonie/station';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const stationLogsTableWNN: string = 'winnonie/stationLog.manageTable';
const filterStationLogsBrandLevel: string = 'winnonie/brand/stationLogs.filters';
const filterStationLogsProjectLevel: string = 'winnonie/project/stationLogs.filters';

export const setManageTableStationLogsWinnonie = (value: WnnServiceManageTable) => {
  set(stationLogsTableWNN, value);
};
export const getManageTableStationLogsWinnonie = (): WnnServiceManageTable => {
  return get(stationLogsTableWNN) || Default.manageTable.winnonieService;
};

export const setFilterStationLogsBrandWinnonie = (value: FilterStationLogs) => {
  set(filterStationLogsBrandLevel, value);
};
export const getFilterStationLogsBrandWinnonie = (): FilterStationLogs => {
  return (
    get(filterStationLogsBrandLevel) || {
      filters: Default.filter.winnonie.stationLogsBrandLevel,
      pages: Default.pages,
    }
  );
};
export const clearFilterStationLogsBrandWinnonie = () => {
  return set(filterStationLogsBrandLevel, {
    filters: Default.filter.winnonie.stationLogsBrandLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterStationLogsBrandWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
export const setFilterStationLogsProjectWinnonie = (value: FilterStationLogs) => {
  set(filterStationLogsProjectLevel, value);
};
export const getFilterStationLogsProjectWinnonie = (): FilterStationLogs => {
  return (
    get(filterStationLogsProjectLevel) || {
      filters: Default.filter.winnonie.stationLogsProjectLevel,
      pages: Default.pages,
    }
  );
};
export const clearFilterStationLogsProjectWinnonie = () => {
  return set(filterStationLogsProjectLevel, {
    filters: Default.filter.winnonie.stationLogsProjectLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterStationLogsProjectWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
